/**
 * Phone normalization (must match PHP PhoneNormalizer / ds_forms_format_phone)
 *
 * @package DesignSchool\Forms
 */

declare var jQuery: any;

/**
 * Normalize phone to E.164 (+digits)
 */
export function normalizePhone(phone: string): string {
    if (!phone) {
        return '';
    }

    const digits = phone.replace(/\D/g, '');
    if (!digits) {
        return '';
    }

    const trimmed = phone.trim();
    if (trimmed.startsWith('+')) {
        return '+' + digits;
    }

    if (digits.length === 11 && (digits.charAt(0) === '7' || digits.charAt(0) === '8')) {
        return '+7' + digits.slice(1);
    }

    if (digits.length === 10 && digits.charAt(0) === '9') {
        return '+7' + digits;
    }

    if ((digits.charAt(0) === '7' || digits.charAt(0) === '8') && digits.length >= 10) {
        return '+7' + digits.slice(1);
    }

    return '+' + digits;
}

/**
 * E.164 check without intl-tel-input instance
 */
export function isValidPhoneE164(phone: string): boolean {
    const normalized = normalizePhone(phone);
    if (!normalized) {
        return false;
    }
    if (/^\+7\d{10}$/.test(normalized)) {
        return true;
    }
    return /^\+[1-9]\d{7,14}$/.test(normalized);
}

/**
 * Read phone value from input (inputmask unmasked value or visible value)
 */
export function getPhoneInputValue($input: any): string {
    if (!$input || !$input.length) {
        return '';
    }

    try {
        if (typeof $input.inputmask === 'function') {
            const unmasked = $input.inputmask('unmaskedvalue');
            if (unmasked && String(unmasked).replace(/\D/g, '').length >= 10) {
                return normalizePhone(String(unmasked));
            }
        }
    } catch {
        // inputmask not attached
    }

    const raw = ($input.val() || '').toString();
    return normalizePhone(raw);
}

/**
 * Apply normalized values to FormData for all phone fields in a form
 */
export function applyPhoneFieldsToFormData($: any, $form: any, formData: FormData): void {
    $form.find('.ds-form__input--phone, input[type="tel"]').each((_: number, element: HTMLElement) => {
        const $field = $(element);
        const name = $field.attr('name');
        if (!name) {
            return;
        }
        const normalized = getPhoneInputValue($field);
        if (normalized) {
            formData.set(name, normalized);
        }
    });
}
